import { commitmentsForTableSelector } from "./source/commitmentsForTableSelector";
import { RootState } from "../../../../store";
import { SavingsPlanData } from "../../../../../services/cloudchipr.api";

export const commitmentsDataForTableSelector = (
  state: RootState,
): SavingsPlanData | undefined => {
  return commitmentsForTableSelector(state)?.data;
};
